import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useModalContext } from '../../contexts/ModalContext';
import { useLogout } from '../../hooks/useLogout';
import AppModal from './Modal';

const ModalPasswordChanged = () => {
    const { t } = useTranslation();
    const { passwordChanged, setPasswordChanged } = useModalContext();
    const { logout } = useLogout();
    const navigate = useNavigate();

    const goHome = () => {
        logout();
        setPasswordChanged(false);
        navigate('/');
    };

    if (!passwordChanged) return <></>;

    return (
        <AppModal
            safeAction={goHome}
            safeText={t('login.sign_in') as string}
        >
            <p>{t('feedback.password_changed')}</p>
        </AppModal>
    );
};

export default ModalPasswordChanged;
